var map = {
	"./homepage.de-CH.json": 1388,
	"./homepage.de-DE.json": 1389,
	"./homepage.en-CA.json": 1390,
	"./homepage.en-GB.json": 1391,
	"./homepage.en-IN.json": 1392,
	"./homepage.en-ME.json": 1393,
	"./homepage.en-US.json": 1394,
	"./homepage.es-EM.json": 1395,
	"./homepage.es-ES.json": 1396,
	"./homepage.fr-BE.json": 1397,
	"./homepage.fr-CA.json": 1398,
	"./homepage.fr-CH.json": 1399,
	"./homepage.nl-BE.json": 1400,
	"./homepage.nl-NL.json": 1401,
	"./homepage.pl-PL.json": 1402,
	"./homepage.pt-BR.json": 1403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1387;